import * as z from 'zod';
import { supportedCutoffCategories } from '../supported-category-cutoffs.constant';
export var testResultsEventSchema = {
    completion: z.literal('complete'),
    result: z.object({
        score: z.number(),
        averageSnr: z.number(),
        pass: z.boolean(),
        category: z.enum(supportedCutoffCategories),
    }),
    steps: z
        .object({
        challenge: z.tuple([z.number(), z.number(), z.number()]),
        response: z.tuple([z.number(), z.number(), z.number()]),
        passed: z.boolean(),
        snr: z.number(),
        timestamp: z.number(),
    })
        .array(),
};
